<template>
  <div>
    <div class="hero-section">
      <div
        class="d-flex justify-content-center align-items-center hero-content"
      >
        <div class="sub-text">
          <h2 class="text-white text-center">Fhenix Africa</h2>
          <p class="text-white text-center small">
            Welcome to Fhenix Africa, a cutting-edge tech company dedicated to
            helping businesses and organizations thrive in the digital age. At
            Fhenix Africa, we are passionate about technology and its ability to
            transform businesses, individuals and industries.
          </p>
          <div class="d-flex justify-content-center align-items-center mt-3">
            <router-link class="btn btn-outline-light" to="/about"
              >About Us</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.hero-section {
  background-image: url("../../assets/Images/knowus.png");
  min-height: 70vh;
  margin: 0 auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.1);
}

.hero-content {
  min-height: 100vh;
}

.hero-content h2 {
  font-size: 64px;
  font-weight: 600;
}

.hero-content p {
  font-size: 18px;
}
.sub-text {
  width: 45%;
}

@media (max-width: 769px) {
  .hero-section {
    min-height: 100vh;
  }
  .hero-content h2 {
    font-size: 32px;
  }

  .hero-content p {
    font-size: 16px;
  }
  .sub-text {
    width: 80% !important;
  }
}
</style>